import { ErrorMessageConstants, MimeTypeService } from "../../common";
import Compressor from 'compressorjs';
const TARGET_IMAGE_QUALITY_FACTOR = 0.8;
const OUTPUT_ORIGINAL_IMAGE_IF_COMPRESSED_SIZE_GREATER = false;
const ROTATE_TARGET_IMAGE_AUTOMATICALLY = false;
export class ImageScalingService {
}
ImageScalingService.compressImage = (inputFile, targetImageSize, maximumImageHeight, maximumImageWidth) => {
    return ImageScalingService.getImageDimension(inputFile).then(({ height, width }) => {
        const allowedMaxHeight = maximumImageHeight !== null && maximumImageHeight !== void 0 ? maximumImageHeight : targetImageSize;
        const allowedMaxWidth = maximumImageWidth !== null && maximumImageWidth !== void 0 ? maximumImageWidth : targetImageSize;
        if (width > allowedMaxWidth || height > allowedMaxHeight) {
            return ImageScalingService.compressImageToTargetSize(inputFile, allowedMaxHeight, allowedMaxWidth);
        }
        return ImageScalingService.noCompressImage(inputFile);
    });
};
ImageScalingService.compressImageToTargetSize = (file, maximumImageHeight, maximumImageWidth, 
/*istanbul ignore next*/ compressWrapper = Compressor) => {
    return new Promise((resolve, reject) => {
        const compressorOptions = {
            strict: OUTPUT_ORIGINAL_IMAGE_IF_COMPRESSED_SIZE_GREATER,
            checkOrientation: ROTATE_TARGET_IMAGE_AUTOMATICALLY,
            quality: TARGET_IMAGE_QUALITY_FACTOR,
            maxHeight: maximumImageHeight,
            maxWidth: maximumImageWidth,
            retainExif: true,
            success: (compressedImage) => resolve(compressedImage),
            error: (error) => reject(error)
        };
        return new compressWrapper(file, compressorOptions);
    });
};
ImageScalingService.isImageScalable = (fileName) => {
    const mimeType = MimeTypeService.lookup(fileName);
    switch (mimeType) {
        case 'image/jpeg':
        case 'image/jpg':
        case 'image/png':
        case 'image/gif':
            return true;
        default:
            return false;
    }
};
ImageScalingService.getImageDimension = (file, 
/*istanbul ignore next*/
image = new Image()) => {
    return new Promise((resolve, reject) => {
        image.src = URL.createObjectURL(file);
        image.onload = () => {
            URL.revokeObjectURL(image.src);
            resolve({ width: image.naturalWidth, height: image.naturalHeight });
        };
        image.onerror = () => {
            URL.revokeObjectURL(image.src);
            reject(ErrorMessageConstants.GENERIC_ERROR_MESSAGE);
        };
    });
};
ImageScalingService.noCompressImage = (file) => {
    return new Promise(resolve => {
        resolve(file);
    });
};
//# sourceMappingURL=ImageScalingService.js.map